import React, { useEffect, useState } from "react";
import { Table, Modal, Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { MdWarningAmber, MdFullscreenExit } from "react-icons/md";
import {
  FiFileText,
  FiAlertCircle,
  FiChevronUp,
  FiChevronDown,
  FiInfo
} from "react-icons/fi";
import "bootstrap/dist/css/bootstrap.min.css";

// MAPPATURA MANUALE DELLE CAUSALI (Aggiungi o modifica qui i testi interi per i tooltip)
// MAPPATURA MANUALE DELLE CAUSALI (Testi interi ricavati dal gestionale)
const dizionarioCausali = {
  "MM": "Mancanza",
  "MC": "Mancanza Cassa",
  "EQ": "Eccedenza per Quantità",
  "ENA": "Eccedenza Non Attesa",
  "D": "Danneggiato",
  "DNA": "Danneggiato Non Atteso",
  "DNA DN_128017": "Danneggiato Non Atteso",
};

const TabellaAnomalie = () => {
  const [loading, setLoading] = useState(true);
  const [totaleAlert, setTotaleAlert] = useState(0);

  const [riepilogoFornitori, setRiepilogoFornitori] = useState([]);
  const [listaCausaliUniche, setListaCausaliUniche] = useState([]);
  const [allLM, setAllLM] = useState([]);

  // Stato per il widget a tutto schermo
  const [showFullscreenModal, setShowFullscreenModal] = useState(false);

  // Stati per l'ordinamento delle colonne
  const [sortConfig, setSortConfig] = useState({
    key: "totaleAnomalie",
    direction: "desc",
  });

  // Stati per i Modali di dettaglio
  const [showAnomalieModal, setShowAnomalieModal] = useState(false);
  const [selectedAnomalieRows, setSelectedAnomalieRows] = useState([]);
  const [selectedFornitoreNome, setSelectedFornitoreNome] = useState("");
  const [causaleSelezionata, setCausaleSelezionata] = useState("");

  const [showLmModal, setShowLmModal] = useState(false);
  const [selectedLmRows, setSelectedLmRows] = useState([]);

  useEffect(() => {
    fetch("ordini_urgenti.json")
      .then((res) => res.json())
      .then((data) => {
        const arrayAnomalie = (data?.ANOMALIE || []).flat();
        const arrayLM = (data?.LM || []).flat();

        setTotaleAlert(arrayAnomalie.length);
        setAllLM(arrayLM);

        // Estrazione dinamica di tutte le causali uniche
        const causaliSet = new Set();
        arrayAnomalie.forEach((a) => {
          if (a.causale) causaliSet.add(a.causale);
        });
        const causaliUniche = Array.from(causaliSet).sort();
        setListaCausaliUniche(causaliUniche);

        // Identificazione fornitori
        const fornitoriSet = new Set([
          ...arrayAnomalie.map((a) => a.ragione_sociale || "FORNITORE NON SPECIFICATO"),
          ...arrayLM.map((lm) => lm["Ragione Sociale"] || "FORNITORE NON SPECIFICATO"),
        ]);

        const righeFornitori = Array.from(fornitoriSet).map((fornitore) => {
          const anomalieFornitore = arrayAnomalie.filter(
            (a) => (a.ragione_sociale || "FORNITORE NON SPECIFICATO") === fornitore,
          );
          const lmFornitore = arrayLM.filter(
            (lm) => (lm["Ragione Sociale"] || "FORNITORE NON SPECIFICATO") === fornitore,
          );

          const conteggioCausali = {};
          causaliUniche.forEach((c) => {
            conteggioCausali[c] = 0;
          });
          anomalieFornitore.forEach((ant) => {
            const causale = ant.causale || "Altro";
            if (conteggioCausali[causale] !== undefined) {
              conteggioCausali[causale]++;
            } else {
              conteggioCausali[causale] = 1;
            }
          });

          const documentiLmDistinti = new Set(
            lmFornitore.map((lm) => lm["Num Doc"]).filter(Boolean)
          );

          return {
            nome: fornitore,
            totaleAnomalie: anomalieFornitore.length,
            dettaglioAnomalie: anomalieFornitore,
            conteggioCausali: conteggioCausali,
            totaleLM: documentiLmDistinti.size,
            dettaglioLM: lmFornitore,
          };
        });

        righeFornitori.sort((a, b) => {
          if (b.totaleAnomalie !== a.totaleAnomalie) {
            return b.totaleAnomalie - a.totaleAnomalie;
          }
          return b.totaleLM - a.totaleLM;
        });

        setRiepilogoFornitori(righeFornitori);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Errore fetch:", err);
        setLoading(false);
      });
  }, []);

  const requestSort = (key) => {
    let direction = "desc";
    if (sortConfig.key === key && sortConfig.direction === "desc") {
      direction = "asc";
    }
    setSortConfig({ key, direction });
  };

  const getSortedFornitori = () => {
    const sortedItems = [...riepilogoFornitori];
    if (sortConfig !== null) {
      sortedItems.sort((a, b) => {
        let valA = a[sortConfig.key];
        let valB = b[sortConfig.key];

        if (listaCausaliUniche.includes(sortConfig.key)) {
          valA = a.conteggioCausali[sortConfig.key] || 0;
          valB = b.conteggioCausali[sortConfig.key] || 0;
        }

        if (typeof valA === "string") {
          return sortConfig.direction === "asc"
            ? valA.localeCompare(valB)
            : valB.localeCompare(valA);
        }

        return sortConfig.direction === "asc" ? valA - valB : valB - valA;
      });
    }
    return sortedItems;
  };

  const renderTooltipSpiegazione = (props) => (
    <Tooltip id="info-rimessi-tooltip" {...props} style={{ ...props.style, fontSize: "0.85rem" }}>
      Questo pannello mostra la matrice delle anomalie BEM suddivise per causale e il totale di documenti LM aperti per fornitore.
      Passa il mouse sulle intestazioni delle causali per leggerne il significato esteso. Solo deposito 04
    </Tooltip>
  );

  const renderTooltipCausale = (causale) => (props) => (
    <Tooltip id={`causale-tooltip-${causale}`} {...props} style={{ ...props.style, fontSize: "0.78rem" }}>
      {dizionarioCausali[causale] || `Causale commerciale: ${causale}`}
    </Tooltip>
  );

  const renderSortIcon = (key) => {
    if (sortConfig.key !== key)
      return (
        <span className="ms-1 text-muted" style={{ opacity: 0.4 }}>
          <FiChevronDown size={10} />
        </span>
      );
    return sortConfig.direction === "asc" ? (
      <FiChevronUp className="ms-1 text-dark" size={12} />
    ) : (
      <FiChevronDown className="ms-1 text-dark" size={12} />
    );
  };

  const formatData = (dateStr) => {
    if (!dateStr || typeof dateStr !== "string") return "-";
    const soloData = dateStr.split(" ")[0];
    return soloData.split("-").reverse().join("/");
  };

  const formatNumero = (valore, decimali = 2) => {
    if (!valore) return "-";
    const num = parseFloat(valore);
    return isNaN(num) ? "-" : num.toFixed(decimali);
  };

  const handleCausaleClick = (e, fornitore, causale) => {
    e.stopPropagation();
    const righeFiltrate = fornitore.dettaglioAnomalie.filter(
      (a) => (a.causale || "Altro") === causale,
    );

    if (righeFiltrate.length === 0) return;

    setSelectedFornitoreNome(fornitore.nome);
    setCausaleSelezionata(causale);
    setSelectedAnomalieRows(righeFiltrate);
    setShowAnomalieModal(true);
  };

  const handleFornitoreClick = (fornitore) => {
    if (fornitore.totaleAnomalie === 0) return;
    setSelectedFornitoreNome(fornitore.nome);
    setCausaleSelezionata("TUTTE");
    setSelectedAnomalieRows(fornitore.dettaglioAnomalie);
    setShowAnomalieModal(true);
  };

  const apriModaleLM = (e, fornitore) => {
    e.stopPropagation();
    setSelectedFornitoreNome(fornitore.nome);
    setSelectedLmRows(fornitore.dettaglioLM);
    setShowLmModal(true);
  };

  const renderTabellaContenuto = () => (
    <Table hover className="table-clean border-0">
      <thead>
        <tr>
          <th style={{ width: "250px" }} onClick={() => requestSort("nome")}>
            Fornitore {renderSortIcon("nome")}
          </th>

          {/* 2. TOOLTIP SULLE TESTATE DELLE CAUSALI */}
          {listaCausaliUniche.map((causale, cIdx) => (
            <OverlayTrigger
              key={cIdx}
              placement="top"
              delay={{ show: 200, hide: 150 }}
              overlay={renderTooltipCausale(causale)}
            >
              <th 
                className="text-center th-causale-interattiva" 
                style={{ width: "120px" }}
                onClick={() => requestSort(causale)}
              >
                {causale} {renderSortIcon(causale)}
              </th>
            </OverlayTrigger>
          ))}

          <th
            style={{ width: "130px" }}
            className="text-center"
            onClick={() => requestSort("totaleLM")}
          >
            LM Aperte {renderSortIcon("totaleLM")}
          </th>
        </tr>
      </thead>
      <tbody>
        {loading ? (
          <tr>
            <td colSpan={listaCausaliUniche.length + 2} className="text-center py-5 text-muted small">
              Aggregazione dati in corso...
            </td>
          </tr>
        ) : riepilogoFornitori.length === 0 ? (
          <tr>
            <td colSpan={listaCausaliUniche.length + 2} className="text-center py-5 text-muted small">
              Nessun dato registrato oggi.
            </td>
          </tr>
        ) : (
          getSortedFornitori().map((fornitore, idx) => (
            <tr
              key={idx}
              className="row-clean"
              onClick={() => handleFornitoreClick(fornitore)}
            >
              <td
                className="fw-semibold text-dark text-truncate"
                style={{ maxWidth: "250px" }}
                title="Clicca per visualizzare tutte le anomalie del fornitore"
              >
                {fornitore.nome}
              </td>

              {/* 1. LOGICA 0 NON CLICCABILE E BADGE GRIGIO */}
              {listaCausaliUniche.map((causale, cIdx) => {
                const qtaAnomalie = fornitore.conteggioCausali[causale] || 0;
                const haAnomalie = qtaAnomalie > 0;
                
                return (
                  <td
                    key={cIdx}
                    className="text-center"
                    onClick={(e) => {
                      if (haAnomalie) {
                        handleCausaleClick(e, fornitore, causale);
                      } else {
                        e.stopPropagation(); // Blocca apertura modale riga se clicchi sullo 0
                      }
                    }}
                    style={{ cursor: haAnomalie ? "pointer" : "default" }}
                  >
                    {haAnomalie ? (
                      <span className="badge-conteggio-attivo text-danger fw-bold">
                        {qtaAnomalie}
                      </span>
                    ) : (
                      <span className="badge-conteggio-vuoto text-muted">
                        0
                      </span>
                    )}
                  </td>
                );
              })}

              <td className="text-center">
                {fornitore.totaleLM > 0 ? (
                  <span
                    className="link-lm d-inline-flex align-items-center gap-1"
                    onClick={(e) => apriModaleLM(e, fornitore)}
                  >
                    <FiFileText size={12} /> {fornitore.totaleLM} {fornitore.totaleLM === 1 ? 'DOC' : 'DOCS'}
                  </span>
                ) : (
                  <span className="text-muted opacity-50">-</span>
                )}
              </td>
            </tr>
          ))
        )}
      </tbody>
    </Table>
  );

  return (
    <>
      {/* CARD STANDARD WIDGET */}
      <div
        className="shadow-sm card"
        style={{
          borderRadius: "14px",
          border: "1px solid #e2e8f0",
          height: "380px",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          backgroundColor: "#fff",
        }}
      >
        {/* Header Widget */}
        <div className="p-3 bg-white border-bottom d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center gap-2">
            <span
              onClick={() => setShowFullscreenModal(true)}
              style={{
                fontWeight: "800",
                fontSize: "0.72rem",
                color: "#0f172a",
                letterSpacing: "0.5px",
                cursor: "pointer",
              }}
              className="d-inline-flex align-items-center gap-1 titolo-header"
              title="Espandi a tutto schermo"
            >
              ANOMALIE BEM DEP. 04
            </span>
            <OverlayTrigger placement="bottom" overlay={renderTooltipSpiegazione}>
              <span style={{ cursor: "pointer", display: "inline-flex", alignItems: "center" }}>
                <FiInfo size={14} color="#adb5bd" />
              </span>
            </OverlayTrigger>
          </div>

          <span
            className="text-danger fw-bold d-flex align-items-center gap-1"
            style={{ fontSize: "0.68rem" }}
          >
            <MdWarningAmber size={14} /> {totaleAlert} ALERT RILEVATI
          </span>
        </div>

        {/* Aggiornamento CSS per i badge di conteggio a 0 e tooltip */}
        <style>{`
          .titolo-header:hover { color: #0284c7 !important; }
          .scroll-area { overflow: auto; flex-grow: 1; background: #fff; }
          .table-clean { margin-bottom: 0; width: 100%; border-collapse: separate; border-spacing: 0; }
          
          .table-clean thead th { 
            position: sticky; top: 0; z-index: 20; 
            background-color: #fff !important; color: #64748b !important; 
            font-size: 0.65rem; text-transform: uppercase; padding: 12px 8px;
            border-bottom: 1px solid #e2e8f0 !important;
            font-weight: 700; letter-spacing: 0.5px;
            cursor: pointer;
            user-select: none;
          }
          .table-clean thead th:hover {
            color: #0f172a !important;
            background-color: #f8fafc !important;
          }
          
          .table-clean tbody td { 
            font-size: 0.75rem; padding: 10px 8px; 
            vertical-align: middle; border-bottom: 1px solid #f1f5f9;
            white-space: nowrap;
          }
          
          .row-clean { transition: background 0.12s ease; cursor: pointer; }
          .row-clean:hover { background-color: #f8fafc !important; }
          
          .badge-conteggio-attivo {
            background-color: #fef2f2;
            color: #ef4444;
            padding: 4px 8px;
            border-radius: 6px;
            border: 1px solid #fee2e2;
            display: inline-block;
            min-width: 28px;
            transition: all 0.15s;
          }
          .badge-conteggio-attivo:hover {
            background-color: #ef4444;
            color: #fff;
          }

          /* Stile per le celle a zero */
          .badge-conteggio-vuoto {
            background-color: #f8fafc;
            color: #94a3b8;
            padding: 4px 8px;
            border-radius: 6px;
            border: 1px solid #e2e8f0;
            display: inline-block;
            min-width: 28px;
            font-weight: 500;
            user-select: none;
          }
          
          .link-lm { 
            color: #0284c7; 
            font-weight: 700; 
            cursor: pointer; 
            padding: 4px 8px; 
            border-radius: 6px; 
            background-color: #f0f9ff;
            border: 1px solid #e0f2fe;
            transition: all 0.15s; 
          }
          .link-lm:hover { 
            color: #fff; 
            background-color: #0284c7; 
          }
          
          .modal-fullscreen-custom .table-clean tbody td { font-size: 0.85rem; padding: 14px 12px; }
          .modal-fullscreen-custom .table-clean thead th { font-size: 0.72rem; padding: 14px 12px; }
        `}</style>

        {/* Corpo della Tabella nella Card */}
        <div className="scroll-area p-0">{renderTabellaContenuto()}</div>
      </div>

      {/* MODALE TUTTO SCHERMO */}
      <Modal
        show={showFullscreenModal}
        onHide={() => setShowFullscreenModal(false)}
        fullscreen={true}
        className="modal-fullscreen-custom"
      >
        <Modal.Header className="px-4 py-3 bg-white border-bottom d-flex align-items-center justify-content-between">
          <Modal.Title
            className="d-flex align-items-center gap-2"
            style={{ fontSize: "1rem", fontWeight: "800", color: "#0f172a" }}
          >
            
            
                        ANOMALIE BEM DEP. 04
            <span
              className="badge bg-danger-subtle text-danger border border-danger-subtle ms-2"
              style={{ fontSize: "0.7rem", padding: "5px 10px" }}
            >
              {totaleAlert} ALERT TOTALI
            </span>
          </Modal.Title>
          <Button
            variant="outline-secondary"
            size="sm"
            className="d-flex align-items-center gap-1 border-0"
            onClick={() => setShowFullscreenModal(false)}
            style={{ fontSize: "0.8rem", fontWeight: "600" }}
          >
            <MdFullscreenExit size={18} /> Chiudi Schermo Intero
          </Button>
        </Modal.Header>
        <Modal.Body className="p-0 scroll-area">
          {renderTabellaContenuto()}
        </Modal.Body>
      </Modal>

      {/* MODALE 1: DETTAGLIO ANOMALIE FILTRATE */}
      <Modal show={showAnomalieModal} onHide={() => setShowAnomalieModal(false)} size="lg" centered className="p-5">
        <Modal.Header closeButton className="border-bottom-0 pt-3 pb-2 px-3">
          <Modal.Title style={{ fontSize: "0.85rem", fontWeight: "800", color: "#0f172a" }}>
            DETTAGLIO ANOMALIE — {selectedFornitoreNome} {causaleSelezionata !== "TUTTE" && `[CAUSALE: ${causaleSelezionata}]`}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0" style={{ maxHeight: "400px", overflowY: "auto" }}>
          <Table responsive hover className="align-middle m-0 table-clean">
            <thead>
              <tr>
                <th>Causale</th>
                <th>Articolo</th>
                <th>Num. Rimesso</th>
                <th>Data Rimesso</th>
                <th>Compl. BEM</th>
              </tr>
            </thead>
            <tbody>
              {selectedAnomalieRows.map((item, rIdx) => (
                <tr key={rIdx}>
                  <td className="fw-semibold text-danger">{item.causale || "-"}</td>
                  <td className="fw-bold text-dark">{item.articolo || "-"}</td>
                  <td className="font-monospace text-secondary">
                    {item.numero_rimesso?.replace(/,$/, "") || "-"}
                  </td>
                  <td>{formatData(item.data_rimesso)}</td>
                  <td className={item.data_completamento_bem ? "text-success fw-medium" : "text-muted"}>
                    {item.data_completamento_bem ? formatData(item.data_completamento_bem) : "In attesa"}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer className="border-top-0 p-2">
          <Button variant="secondary" size="sm" onClick={() => setShowAnomalieModal(false)}>
            Chiudi
          </Button>
        </Modal.Footer>
      </Modal>

      {/* MODALE 2: DETTAGLIO DOCUMENTI LM */}
      <Modal show={showLmModal} onHide={() => setShowLmModal(false)} size="xl" centered className="p-5">
        <Modal.Header closeButton className="border-bottom-0 pt-3 pb-2 px-3">
          <Modal.Title style={{ fontSize: "0.85rem", fontWeight: "800", color: "#0f172a" }}>
            REGISTRO DOCUMENTI LM — {selectedFornitoreNome}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0" style={{ maxHeight: "450px", overflowY: "auto" }}>
          <Table responsive hover className="align-middle m-0 table-clean">
            <thead>
              <tr>
                <th>Dep</th>
                <th>Tipo Doc</th>
                <th>Num Doc</th>
                <th>Data Doc</th>
                <th>Precodice</th>
                <th>Articolo</th>
                <th>Descrizione</th>
                <th className="text-center">Qta</th>
                <th>Netto (€)</th>
                <th>Importo (€)</th>
                <th>Note Lista / Dettagli Reso</th>
              </tr>
            </thead>
            <tbody>
              {selectedLmRows.map((lm, index) => (
                <tr key={index}>
                  <td className="text-start">{lm["Deposito"] || "-"}</td>
                  <td className="fw-semibold text-info">{lm["Tipo Doc"] || "LM"}</td>
                  <td className="fw-semibold">{lm["Num Doc"] || "-"}</td>
                  <td>{formatData(lm["Data Doc"])}</td>
                  <td>{lm["Precodice"] || "-"}</td>
                  <td className="fw-bold text-primary">{lm["Articolo"] || "-"}</td>
                  <td className="text-truncate" style={{ maxWidth: "150px" }} title={lm["Descrizione"]}>
                    {lm["Descrizione"] || "-"}
                  </td>
                  <td className="fw-bold text-center">{formatNumero(lm["Qta"], 0)}</td>
                  <td>{formatNumero(lm["Netto"], 2)}</td>
                  <td className="fw-bold">{formatNumero(lm["Importo"], 2)}</td>
                  <td className="text-muted small" style={{ maxWidth: "220px", whiteSpace: "normal" }}>
                    {lm["Note Lista"] || lm["Note Doc"] || "-"}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer className="border-top-0 p-2">
          <Button variant="secondary" size="sm" onClick={() => setShowLmModal(false)}>
            Chiudi Registro
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default TabellaAnomalie;